import 'react';
import 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import _Popover from 'reakit/Popover';

var PopoverHide = styled(_Popover.Hide).withConfig({
  displayName: "styled__PopoverHide",
  componentId: "sc-12khuk0-0"
})(["", ";"], theme('fannypack.Popover.Hide.base'));
var PopoverShow = styled(_Popover.Show).withConfig({
  displayName: "styled__PopoverShow",
  componentId: "sc-12khuk0-1"
})(["", ";"], theme('fannypack.Popover.Show.base'));
var PopoverToggle = styled(_Popover.Toggle).withConfig({
  displayName: "styled__PopoverToggle",
  componentId: "sc-12khuk0-2"
})(["", ";"], theme('fannypack.Popover.Toggle.base'));
var PopoverClose = styled(Button).withConfig({
  displayName: "styled__PopoverClose",
  componentId: "sc-12khuk0-3"
})(["position:absolute;width:24px;min-height:24px;right:0;top:0;padding:0px;text-align:right;", ";"], theme('fannypack.Popover.Close.base'));
var Popover = styled(_Popover).withConfig({
  displayName: "styled__Popover",
  componentId: "sc-12khuk0-4"
})(["display:block;padding:", "rem;", ";"], space(5), theme('fannypack.Popover.base'));

export default Popover;
export { Popover, PopoverClose, PopoverHide, PopoverShow, PopoverToggle };
